import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../assets/css/signin.scss'
import { Link, useNavigate } from 'react-router-dom';
import googleIcon from '../assets/images/signin/google.png'
import linkedIcon from '../assets/images/signin/linkedin.png'
import companyLogo from '../assets/images/signin/logo-dark-copy.png'
import { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { loadCountryCodeDropdown, postSignUpUserData } from './redux/action';
import * as HeaderAuthentication from '../components/HeaderAuthentication';
import bannerMain from '../assets/images/Signin_Banner.png';
import shieldIcon from '../assets/images/shield.png';
import ChartColumnIcon from '../assets/images/chartColumn.png';
import locationIcon from '../assets/images/locationIcon.png';
import usersIcon from '../assets/images/usersIcon.png';
import { baseURL } from './BaseURL';

const SignUp = () => {

    useEffect(() => {
        // Partner ID
        window._linkedin_partner_id = "9649100";
        window._linkedin_data_partner_ids =
            window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

        // Prevent loading multiple times
        if (!document.getElementById("linkedin-insight-script")) {
            window.lintrk =
                window.lintrk ||
                function (a, b) {
                    window.lintrk.q = window.lintrk.q || [];
                    window.lintrk.q.push([a, b]);
                };

            const script = document.createElement("script");
            script.id = "linkedin-insight-script";
            script.type = "text/javascript";
            script.async = true;
            script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

            document.head.appendChild(script);
        }
    }, []);

    let dispatch = useDispatch();
    const navigate = useNavigate();
    const formRef = useRef(null);
    const { countryCodeDropdown } = useSelector((state) => state.data);

    const [signUpStatus, setSignUpStatus] = useState(false)

    useEffect(() => {
        // const getCountry = async () => {
        //     try {
        //         const res = await fetch("https://ipapi.co/json/");
        //         const data = await res.json();

        //         console.log(data, "data")

        //         const selectedCountry = countryCodeDropdown.find(
        //             item =>
        //                 item.country_name.toLowerCase() ===
        //                 data.country_name.toLowerCase()
        //         );

        //         if (selectedCountry) {
        //             alert(selectedCountry)
        //             setFormData(prev => ({
        //                 ...prev,
        //                 mobile_code: selectedCountry
        //             }));
        //         }
        //     } catch (err) {
        //         console.error(err);
        //     }
        // };

        const getCountry = async () => {
            try {
                const res = await fetch("https://ipwho.is/");
                const data = await res.json();

                if (data.success) {
                    const selectedCountry = countryCodeDropdown.find(
                        item =>
                            item.country_name.toLowerCase() ===
                            data.country.toLowerCase()
                    );

                    if (selectedCountry) {
                        setFormData(prev => ({
                            ...prev,
                            mobile_code: selectedCountry
                        }));
                    }
                }

            } catch (err) {
                console.error(err);
            }
        };

        if (countryCodeDropdown.length > 0) {
            getCountry();
        }
    }, [countryCodeDropdown]);



    const [formData, setFormData] = useState({
        user_name: '',
        mobile_code: { label: '', value: '' },
        to_email: '',
        phone: '',
        company_name: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadCountryCodeDropdown());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const hideSwal = useRef(false);
    const tokenClientRef = useRef(null);

    // region for google login
    const handleGoogleCallback = async (tokenResponse) => {
        try {
            const res = await fetch(
                "https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,emailAddresses,names",
                {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                }
            );

            const data = await res.json();

            const userData = {
                name: data.names?.[0]?.displayName || "",
                email: data.emailAddresses?.[0]?.value || "",
                mobile_code: "",
                phoneNumber: data.phoneNumbers?.[0]?.value || "",
                company_name: "",
            };

            hideSwal.current = true;

            handleSignUp(userData);
        } catch (error) {
            console.error("Failed to fetch Google profile:", error);
        }
    };

    const initializeGoogleClient = () => {
        if (!window.google?.accounts?.oauth2) {
            console.log("Google SDK not loaded");
            return false;
        }

        tokenClientRef.current =
            window.google.accounts.oauth2.initTokenClient({
                client_id: '762425997431-plapsidtr0nm2kjfkc9vrk6vcv2lsfa2.apps.googleusercontent.com',
                scope:
                    "openid profile email https://www.googleapis.com/auth/user.phonenumbers.read",
                callback: handleGoogleCallback,
            });

        console.log("Google Token Client Initialized");

        return true;
    };

    useEffect(() => {
        if (window.google?.accounts?.oauth2) {
            initializeGoogleClient();
            return;
        }

        const interval = setInterval(() => {
            if (window.google?.accounts?.oauth2) {
                clearInterval(interval);
                initializeGoogleClient();
            }
        }, 300);

        return () => clearInterval(interval);
    }, []);
    // endregion

    useEffect(() => {

        const params = new URLSearchParams(
            window.location.search
        );

        if (params) {
            if (params.get("email")) {
                const user = {
                    linkedinId: params.get("id"),
                    name: params.get("name"),
                    email: params.get("email"),
                    picture: params.get("picture")
                };

                const signUpData = {
                    name: user.name,
                    mobile_code: "",
                    email: user.email,
                    phoneNumber: "",
                    company_name: "",
                };
                hideSwal.current = true;
                handleSignUp(signUpData);
            }

            // localStorage.setItem(
            //     "linkedinUser",
            //     JSON.stringify(user)
            // );
        }

    }, []);


    const validate = () => {
        const newErrors = {};
        if (!formData.user_name.trim()) newErrors.user_name = 'Full name is required';
        if (!formData.to_email.trim()) newErrors.to_email = 'Email address is required';
        if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
        return newErrors;
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [field]: '',
        }));
    };

    const AddSignUpData = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setSignUpStatus(true)

        const signUpData = {
            name: formData.user_name,
            mobile_code: formData.mobile_code.value,
            email: formData.to_email,
            phoneNumber: formData.phone,
            company_name: formData.company_name,
        };

        // console.log(signUpData, "signUpData")
        hideSwal.current = false;
        handleSignUp(signUpData);
    };

    const handleSignUp = (data) => {
        const signUpData = {
            user_name: data.name,
            mobile_code: data.mobile_code,
            to_email: data.email,
            phone: data.phoneNumber,
            company_name: data.company_name,
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(signUpData),
        };

        dispatch(postSignUpUserData(requestOption, hideSwal.current, data.email)).then(
            (resp) => {
                setSignUpStatus(false)
            }
        ).catch((err) => {

        });;
    }

    // const handleGetPhone = () => {
    //     if (tokenClientRef.current) {
    //         tokenClientRef.current.requestAccessToken();
    //     } else {
    //         console.error("Token client not initialized");
    //     }
    // };

    const handleGetPhone = () => {
        if (!tokenClientRef.current) {
            console.log("Reinitializing Google client...");

            const initialized = initializeGoogleClient();

            if (!initialized) {
                console.error("Google SDK not loaded.");
                return;
            }
        }

        tokenClientRef.current.requestAccessToken({
            prompt: "select_account",
        });
    };

    // const handleLinkedInLogin = () => {
    //     setLinkedInLogin(true)
    //     const clientId = "86opkgjrw1jcp4";
    //     const redirectUri = `${baseURL}/lm_login/oauth/linkedin/callback`;
    //     // const redirectUri = `${baseURL}/oauth/linkedin/callback`;

    //     const email = "";

    //     const stateObj = { email: email, ts: Date.now() };
    //     const state = btoa(JSON.stringify(stateObj));// const state = crypto.randomUUID(); // generate random state for security
    //     // const scope = "openid profile email"; // ✅ new scopes
    //     const scope = "openid"; // ✅ new scopes

    //     const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
    //         redirectUri
    //     )}&scope=${encodeURIComponent(scope)}&state=${state}`;

    //     window.location.href = authUrl;
    // };

    const handleLinkedInLogin = () => {
        const clientId = "86opkgjrw1jcp4";
        const redirectUri = `${baseURL}/lm_login/oauth/linkedin/callback`;

        const email = "";

        const stateObj = { email: email, ts: Date.now() };
        const state = btoa(JSON.stringify(stateObj));
        const scope = "openid profile email";

        const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
            redirectUri
        )}&scope=${encodeURIComponent(scope)}&state=${state}`;

        sessionStorage.setItem("socialLogin", "linkedin");
        window.location.href = authUrl;
    };

    useEffect(() => {
        const handleLinkedInCallback = async () => {
            const params = new URLSearchParams(window.location.search);

            console.log(params, "params")
            if (params.size > 0) {
                const code = params.get("code");
                const state = params.get("state");
                if (!code) {
                    console.error("No LinkedIn code returned");
                    return;
                }

                try {
                    // 1. Exchange code for token (call your ORDS backend)
                    const tokenRes = await fetch(
                        `${baseURL}/lm_login/api/linkedin/token`,
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ code })
                        }
                    );
                    const { access_token } = await tokenRes.json();

                    // 2. Fetch LinkedIn profile
                    const profileRes = await fetch("https://api.linkedin.com/v2/userinfo", {
                        headers: { Authorization: `Bearer ${access_token}` }
                    });
                    const profile = await profileRes.json();

                    const signUpData = {
                        user_name: profile.name,
                        mobile_code: "",
                        to_email: profile.email,
                        phone: "",
                        company_name: ""
                    };

                    // 3. Send to your backend
                    let requestOption = {
                        method: "POST",
                        mode: "cors",
                        headers: HeaderAuthentication.postAuthOfLeadMerge,
                        body: JSON.stringify(signUpData),
                    };

                    dispatch(postSignUpUserData(requestOption, true, profile.email));

                    // 4. Redirect user
                    navigate("/dashboard");
                } catch (err) {
                    console.error("LinkedIn login failed:", err);
                }
            }
        };

        handleLinkedInCallback();
    }, [dispatch, navigate]);


    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                formRef.current?.requestSubmit();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return (
        // <Container fluid className="signin-container">
        //     <Row className="signin-row">
        //         {/* Left Column - Image */}
        //         <Col md={6} className="signin-first-col">
        //             <dotlottie-player
        //                 src="https://lottie.host/38083418-3526-4b48-947a-c2f397e7f5df/uJRHRxuGKS.lottie"
        //                 background="transparent"
        //                 speed="1"
        //                 // style={{ width: '500px', height: '500px' }}
        //                 loop
        //                 autoplay
        //                 className='lottie-img'
        //             ></dotlottie-player>
        //         </Col>

        //         {/* Right Column - Form */}
        //         <Col md={6} className="signin-second-col">
        //             <img src={companyLogo} className='companyLogo' alt="" />
        //             <h6 className="text-center">Create a new account</h6>
        //             <span>Get your Leadmerge account now.</span>
        //             <Form ref={formRef} className='signin-form-container' onSubmit={AddSignUpData}>
        //                 <Form.Group className="mb-3" controlId="formName">
        //                     <Form.Control
        //                         type="text"
        //                         placeholder="Your Full Name"
        //                         value={formData.name}
        //                         onChange={(e) => handleChange('user_name', e.target.value)}
        //                     />
        //                     {errors.user_name && <div className="text-danger">{errors.user_name}</div>}
        //                 </Form.Group>

        //                 <Form.Group className="mb-3" controlId="formEmail">
        //                     <Form.Control
        //                         type="email"
        //                         placeholder="Email Address"
        //                         value={formData.email}
        //                         onChange={(e) => handleChange('to_email', e.target.value)}
        //                     />
        //                     {errors.to_email && <div className="text-danger">{errors.to_email}</div>}
        //                 </Form.Group>

        //                 <Form.Group controlId="formPhone" className='mb-3'>
        //                     <div className="d-flex align-items-start">
        //                         <div style={{ width: '20%' }}>
        //                             <Select
        //                                 options={countryCodeDropdown}
        //                                 value={formData.mobile_code}
        //                                 onChange={(selectedOption) => handleChange('mobile_code', selectedOption)}
        //                             />
        //                         </div>
        //                         <div style={{ width: '80%' }}>
        //                             <Form.Control
        //                                 type="tel"
        //                                 placeholder="Phone Number"
        //                                 className="ms-2"
        //                                 style={{ width: '100%' }}
        //                                 value={formData.phone}
        //                                 maxLength={10}
        //                                 isInvalid={formData.phone.length > 0 && formData.phone.length < 10}
        //                                 onChange={(e) => {
        //                                     const value = e.target.value.replace(/\D/g, ""); // Allow only digits
        //                                     handleChange("phone", value);
        //                                 }}
        //                             />
        //                             <Form.Control.Feedback type="invalid">
        //                                 Phone number must be 10 digits.
        //                             </Form.Control.Feedback>
        //                         </div>
        //                     </div>

        //                     {errors.phone && <div className="text-danger">{errors.phone}</div>}
        //                 </Form.Group>

        //                 <Form.Group className="mb-3" controlId="formCompany">
        //                     <Form.Control
        //                         type="text"
        //                         placeholder="Company Name (Optional)"
        //                         value={formData.company}
        //                         onChange={(e) => handleChange('company_name', e.target.value)}
        //                     />
        //                     {errors.company_name && <div className="text-danger">{errors.company_name}</div>}
        //                 </Form.Group>

        //                 <Button variant="primary" type="submit" className="w-100" disabled={signUpStatus}>
        //                     {signUpStatus ? "Processing..." : "Sign Up"}
        //                 </Button>

        //                 <div className="divider-container">
        //                     <div className="line"></div>
        //                     <p className="text">Or continue with</p>
        //                     <div className="line"></div>
        //                 </div>
        //                 <div className='lm-login-btns-section'>
        //                     <div className='btn-div' onClick={handleGetPhone}>
        //                         <img src={googleIcon} alt="" /> &nbsp; Google
        //                     </div>
        //                     <div className='btn-div' onClick={handleLinkedInLogin}>
        //                         <img src={linkedIcon} alt="" /> &nbsp; Linked In
        //                     </div>
        //                 </div>
        //                 <div className='signin-signup-link'>
        //                     <p>Already have an account? <Link to='/'> Sign In </Link></p>
        //                 </div>
        //             </Form>
        //         </Col>
        //     </Row>
        // </Container>
        <Container fluid className="signin-container">

            <Row className="signin-row">

                <Col md={6} className="signin-first-col signinLeftContent">
                    <div className="hero-shape">
                        <div className="dot-pattern"></div>
                    </div>
                    <img src={companyLogo} className='signinCompanyLogo' alt="" />
                    <div>
                        <h6>AI-Powered Marketing</h6>
                        <h4><span>Better </span>Leads. Bigger Growth.</h4>
                        <p>LeadMerge helps B2B businesses generate high-quality leads,
                            optimize campaigns, and maximize ROI with AI-driven insights.</p>
                        <div className="myBannerSection">
                            <div className="features-list">

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        {/* <i className="fa-solid fa-user-group"></i> */}
                                        <img src={usersIcon} className='shieldImage' alt="usersIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>High-Quality Leads</h4>
                                        <p>Reach the right audience and boost conversions.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        {/* <i className="fa-solid fa-crosshairs"></i> */}
                                        <img src={locationIcon} className='shieldImage' alt="locationIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Smart Campaigns</h4>
                                        <p>AI-optimized campaigns for better performance.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <img src={ChartColumnIcon} className='shieldImage' alt="ChartColumnIcon" />
                                        {/* <i className="fa-solid fa-chart-column"></i> */}
                                    </div>
                                    <div className="feature-content">
                                        <h4>Maximize ROI</h4>
                                        <p>Data-driven insights to grow your business.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <img src={shieldIcon} className='shieldImage' alt="shieldIcon" />
                                        {/* <i className="fa-solid fa-shield-halved"></i> */}
                                    </div>
                                    <div className="feature-content">
                                        <h4>Secure & Reliable</h4>
                                        <p>Enterprise-grade security for your data.</p>
                                    </div>
                                </div>

                            </div>
                            <div className="bannerContent">
                                <img src={bannerMain} className='bannerMianImage' alt="Banner" />
                            </div>
                        </div>
                    </div>
                    {/* <img className='banner-img' src={bannerLogo} alt="" /> */}

                </Col>

                <Col md={6} className="signin-second-col">
                    <div className="formSection">
                        <div className="loginIcon">
                            {/* <i className="fa-regular fa-shield-check"></i> */}
                            <img src={shieldIcon} className='shieldImage' alt="shieldIcon" />
                        </div>

                        <h3 className="text-center">Create Account</h3>
                        <p className="text-center">Get your LeadMerge account now.</p>

                        <Form ref={formRef} className="signin-form-container" onSubmit={AddSignUpData}>

                            <Form.Group className="mb-3 position-relative">
                                <i className="fa-regular fa-user inputIcon"></i>

                                <Form.Control
                                    type="text"
                                    placeholder="Full Name"
                                    value={formData.user_name}
                                    // onChange={(e) => handleChange("user_name", e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Allow only letters and spaces
                                        if (/^[A-Za-z\s]*$/.test(value)) {
                                            handleChange("user_name", value);
                                        }
                                    }}
                                />

                                {errors.user_name && (
                                    <div className="text-danger">{errors.user_name}</div>
                                )}
                            </Form.Group>


                            <Form.Group className="mb-3 position-relative">
                                <i className="fa-regular fa-envelope inputIcon"></i>

                                <Form.Control
                                    type="email"
                                    placeholder="Email Address"
                                    value={formData.to_email}
                                    onChange={(e) => handleChange("to_email", e.target.value)}
                                />

                                {errors.to_email && (
                                    <div className="text-danger">{errors.to_email}</div>
                                )}
                            </Form.Group>


                            <Form.Group className="mb-3 position-relative mobileRow">

                                <div className="d-flex">

                                    <div style={{ width: "28%" }}>
                                        <Select
                                            options={countryCodeDropdown}
                                            value={formData.mobile_code}
                                            onChange={(selectedOption) =>
                                                handleChange("mobile_code", selectedOption)
                                            }
                                        />
                                    </div>

                                    <div
                                        className="position-relative ms-2"
                                        style={{ width: "72%" }}
                                    >
                                        <i className="fa-solid fa-phone inputIcon"></i>

                                        <Form.Control
                                            type="tel"
                                            placeholder="Phone Number"
                                            value={formData.phone}
                                            maxLength={10}
                                            isInvalid={formData.phone.length > 0 && formData.phone.length < 10}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                                                handleChange("phone", value);
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Phone number must be 10 digits.
                                        </Form.Control.Feedback>
                                    </div>

                                </div>

                                {errors.phone && (
                                    <div className="text-danger">{errors.phone}</div>
                                )}

                            </Form.Group>


                            <Form.Group className="mb-3 position-relative">

                                <i className="fa-solid fa-building inputIcon"></i>

                                <Form.Control
                                    type="text"
                                    placeholder="Company Name (Optional)"
                                    value={formData.company_name}
                                    onChange={(e) =>
                                        handleChange("company_name", e.target.value)
                                    }
                                />

                                {errors.company_name && (
                                    <div className="text-danger">
                                        {errors.company_name}
                                    </div>
                                )}

                            </Form.Group>

                            <Button
                                variant="primary"
                                type="submit"
                                className="w-100"
                                disabled={signUpStatus}
                            >
                                {signUpStatus ? "Creating..." : "Create Account"}
                            </Button>

                            <div className="divider-container">
                                <div className="line"></div>
                                <p className="text">Or continue with</p>
                                <div className="line"></div>
                            </div>

                            <div className='lm-login-btns-section'>
                                <div className='btn-div' onClick={handleGetPhone}>
                                    <img src={googleIcon} alt="GoogleIcon" /> &nbsp; Google
                                </div>
                                <div className='btn-div' onClick={handleLinkedInLogin}>
                                    <img src={linkedIcon} alt="LinkedinIcon" />&nbsp; Linkedin
                                </div>
                            </div>

                            <div className="signin-signup-link">
                                <p>
                                    Already have an account?
                                    <Link to="/"> Sign In </Link>
                                </p>
                            </div>

                        </Form>
                    </div>
                </Col>
                <div className="copyright_text">
                    <h6>Copyright @ 2026 <span>Leadmerge LLC</span></h6>
                </div>
            </Row>
        </Container>
    );
};

export default SignUp;
